import { purchaseResponse } from 'src/services/responseTypes/rentalPurchaseResponse';

import { TVOD_PURCHASE_STATUS } from './constants/AppConstants';

// Method to filter Duplicate Movies, retain latest purchaced movies
export const filterDuplicateData = (allPurchaseData: purchaseResponse[]) => {
  let uniquePurchases = [];
  const uniquePurchasesMap = new Map();
  if (allPurchaseData && allPurchaseData.length) {
    allPurchaseData.forEach((item: purchaseResponse) => {
      if (uniquePurchasesMap.get(item.asset_id)) {
        const duplicateItem = uniquePurchasesMap.get(item.asset_id);
        if (item.purchase_end > duplicateItem.purchase_end) {
          uniquePurchasesMap.set(item.asset_id, item);
        }
      } else {
        uniquePurchasesMap.set(item.asset_id, item);
      }
    });
  }
  uniquePurchases = Array.from(uniquePurchasesMap.values());
  return uniquePurchases;
};

export const getStatusForTvod = (
  receivedDate: string,
  playbackState: string
) => {
  let status = TVOD_PURCHASE_STATUS.EXPIRED;
  if (receivedDate) {
    const packExpiryDate = new Date(receivedDate);
    const today = new Date();
    if (packExpiryDate > today && /(purchased|watching)/.test(playbackState)) {
      status = TVOD_PURCHASE_STATUS.ACTIVE;
    }
  }
  return status;
};

export const updateTVODRentals = (rentalPurchases: purchaseResponse[]) => {
  if (Array.isArray(rentalPurchases) && rentalPurchases.length) {
    const activeRentalPurchases: purchaseResponse[] = [];
    const expiredRentalPurchases: purchaseResponse[] = [];
    const uniqueRentalPurchases = filterDuplicateData(rentalPurchases);
    uniqueRentalPurchases.forEach((item) => {
      const { purchase_end, playback_state } = item;
      const packStatus = getStatusForTvod(purchase_end, playback_state);
      if (packStatus === 'Active') {
        activeRentalPurchases.push(item);
      } else {
        expiredRentalPurchases.push(item);
      }
    });
    const activeAssetIDs = activeRentalPurchases.map(
      (item: purchaseResponse) => item.asset_id
    );
    const expiredAssetIDs = expiredRentalPurchases.map(
      (item: purchaseResponse) => item.asset_id
    );
    return {
      activeRentalPurchases,
      expiredRentalPurchases,
      uniqueRentalPurchases,
      activeAssetIDs,
      expiredAssetIDs,
      allRentalPurchases: rentalPurchases
    };
  }
  return null;
};
